"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIAbstractDateInput = _interopRequireDefault(require("./abstract/UIAbstractDateInput"));

var _UIAbstractDropdown = _interopRequireDefault(require("../dropdown/abstract/UIAbstractDropdown"));

var _UIAutosizedTextInput = _interopRequireDefault(require("../input/UIAutosizedTextInput"));

var noop = function noop() {
  return null;
};

var UIDatePicker = _react.default.createClass({
  displayName: "UIDatePicker",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UIAbstractDateInput.default.propTypes, ['children']), {
    caretRenderer: _UIAbstractDropdown.default.propTypes.caretRenderer,
    inputClassName: _react.PropTypes.string,
    size: _react.PropTypes.oneOf(['small', 'default']),
    use: _react.PropTypes.oneOf(['default', 'on-dark']),
    disabled: _react.PropTypes.bool,
    readOnly: _react.PropTypes.bool
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIAbstractDateInput.default.defaultProps, {
      size: 'default',
      use: 'default'
    });
  },
  componentDidMount: function componentDidMount() {
    var thisEl = (0, _reactDom.findDOMNode)(this._abstractDateInput);
    if (thisEl) thisEl.addEventListener('click', this.handleDirectClick);
  },
  componentWillUnmount: function componentWillUnmount() {
    var thisEl = (0, _reactDom.findDOMNode)(this._abstractDateInput);
    if (thisEl) thisEl.removeEventListener('click', this.handleDirectClick);
  },
  handleDirectClick: function handleDirectClick(evt) {
    // Prevent Pickadate from detecting this click and closing itself
    evt.preventDefault();
    evt.stopPropagation();
  },
  focus: function focus() {
    if (this._abstractDateInput) {
      this._abstractDateInput.focus();
    }
  },
  select: function select() {
    if (this._abstractDateInput) {
      this._abstractDateInput.select();
    }
  },
  handleMouseDown: function handleMouseDown(evt) {
    if (this._abstractDateInput) {
      if (this._abstractDateInput.state.hasFocus) {
        this._abstractDateInput.handleMouseDown(evt);

        evt.preventDefault(); // Don't trigger blur
      } else {
        this._abstractDateInput.focus();

        evt.preventDefault();
        evt.stopPropagation();
      }
    }
  },
  getButtonSize: function getButtonSize(_ref) {
    var size = _ref.size,
        use = _ref.use;

    if (size === 'small' && use === 'on-dark') {
      return 'small';
    }

    return 'default';
  },
  getButtonUse: function getButtonUse(_ref2) {
    var size = _ref2.size,
        use = _ref2.use;

    // default size + default use
    if (size === 'default' && use === 'default') {
      return 'form';
    } // default size + on-dark


    if (size === 'default') {
      return 'form-on-dark';
    } // small + default use


    if (use === 'default') {
      return 'link';
    } // small + on-dark


    return 'tertiary-light';
  },
  abstractDateInputRefCallback: function abstractDateInputRefCallback(ref) {
    this._abstractDateInput = ref;
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        caretRenderer = _this$props.caretRenderer,
        className = _this$props.className,
        disabled = _this$props.disabled,
        inputClassName = _this$props.inputClassName,
        readOnly = _this$props.readOnly,
        size = _this$props.size,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["caretRenderer", "className", "disabled", "inputClassName", "readOnly", "size", "use"]);
    var buttonSize = this.getButtonSize({
      size: size,
      use: use
    });
    var buttonUse = this.getButtonUse({
      size: size,
      use: use
    });
    return _react.default.createElement(_UIAbstractDateInput.default, (0, _extends2.default)({}, rest, {
      className: "private-date-picker",
      disabled: disabled,
      readOnly: readOnly,
      ref: this.abstractDateInputRefCallback
    }), function (dateProps) {
      var ariaInvalid = dateProps['aria-invalid'],
          isPickerOpen = dateProps.isPickerOpen,
          datePropsRest = (0, _objectWithoutProperties2.default)(dateProps, ["aria-invalid", "isPickerOpen"]);
      return _react.default.createElement(_UIAbstractDropdown.default, {
        "aria-invalid": ariaInvalid,
        "aria-pressed": isPickerOpen,
        buttonText: _react.default.createElement(_UIAutosizedTextInput.default, (0, _extends2.default)({}, datePropsRest, {
          className: "private-datepicker__input-wrapper",
          inputClassName: (0, _classNames.default)('private-datepicker__input', inputClassName, {
            'private-datepicker__input--as-link': buttonUse === 'link'
          }, {
            'private-datepicker__input--readonly': readOnly
          })
        })),
        buttonSize: buttonSize,
        buttonUse: buttonUse,
        caretRenderer: caretRenderer,
        className: (0, _classNames.default)('private-date-picker__button', className, {
          'private-form__control--on-dark': size === 'small' && use === 'on-dark'
        }),
        closeOnOutsideClick: false,
        disabled: disabled,
        readOnly: readOnly,
        iconName: "date",
        onMouseDown: _this.handleMouseDown,
        onOpenChange: noop,
        open: false,
        tabIndex: -1
      });
    });
  }
});

var _default = (0, _Controllable.default)(UIDatePicker);

exports.default = _default;
module.exports = exports.default;